import connect from './connect';

export { UserProfileScreen } from './UserProfileScreen';

export default connect;
